import React from 'react'
import styled from 'styled-components'

import RDCLogoSrc from '../../../../images/RDC_RED_Logo_House.svg'

const RDCLogo = styled.img`
  height: 53.83px;
  width: 54px;
  margin-top:90px;
`
const RdcBrandedLogo = () => (
    <RDCLogo src={RDCLogoSrc} />
)

export default RdcBrandedLogo
